import { render } from "./H01PointConfirmItem.vue?vue&type=template&id=56c8aa88&scoped=true&ts=true"
import script from "./H01PointConfirmItem.vue?vue&type=script&lang=ts"
export * from "./H01PointConfirmItem.vue?vue&type=script&lang=ts"

import "./H01PointConfirmItem.vue?vue&type=style&index=0&id=56c8aa88&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56c8aa88"]])

export default __exports__